import type { FC } from 'react';
import React from 'react';
import { format } from 'date-fns';
import classnames from 'classnames';
import ruLocale from 'date-fns/locale/ru';

import { useTranslation } from '@lt/localization';
import { pluralizePerson } from 'src/utils/pluralizeUtils';

import styles from './searcher.module.css';

interface Props {
  cityFrom: string;
  startDate?: Date;
  endDate?: Date;
  adults: number;
  kidsCount: number;
  onExpand(): void;
  className?: string;
  isHotelOnly: boolean;
}

const SearcherFormClamped: FC<Props> = ({
  cityFrom,
  startDate,
  endDate,
  adults,
  kidsCount = 0,
  onExpand,
  className = '',
  isHotelOnly,
}) => {
  const { t } = useTranslation();
  const startDateFormattedFns =
    startDate &&
    format(startDate, 'd MMMM', {
      locale: ruLocale,
    });
  const endDateFormattedFns =
    endDate && format(endDate, 'd MMMM', { locale: ruLocale });

  return (
    <div className={classnames(styles.searcherFormClampedContainer, className)}>
      <h2 className={styles.searcherFormClampedH2}>
        <span>{`${t(
          'hotel.cigarette.mobile.startDate',
        )}${startDateFormattedFns} `}</span>
        <span>{`${t(
          'hotel.cigarette.mobile.endDate',
        )}${endDateFormattedFns}`}</span>
        <span>{' · '}</span>
        <span>{`${adults + kidsCount} ${pluralizePerson(
          adults + kidsCount,
        )}`}</span>
        {!isHotelOnly && (
          <span>{` ${t('hotel.cigarette.mobile.from')} ${cityFrom}`}</span>
        )}
      </h2>
      <button
        type="button"
        className={styles.searcherFormClampedButton}
        onClick={onExpand}
      >
        {t('hotel.cigarette.mobile.buttonChange')}
      </button>
    </div>
  );
};

export default SearcherFormClamped;
